const accountingProviders = {
  qbo: { id: 'qbo', name: 'QuickBooks' },
  xero: { id: 'xero', name: 'Xero' },
  sage: { id: 'sage', name: 'Sage Intacct' },
};

export default accountingProviders;
